<template>
  <div class="have-class">
    <div class="have-class-title">{{msg.title}}</div>
    <div class="have-class-source">{{msg.creationtime|times}}</div>
    <div class="have-class-html" v-html="msg.content" v-show="videoUrl==''"></div>
    <div class="have-class-video" v-show="videoUrl!=''">
      <video id="video" :src="videoUrl" controls></video>
    </div>
  </div>
</template>
<script>
// import videoImg from "@/assets/testMv.mp4";
export default {
  data() {
    return {
      msg: {},
      videoUrl: "",
      videoDom: "",
      videoInterval: "",
      videoAllTime: 0
    };
  },
  mounted() {
    this.getMsg();
  },
  methods: {
    getMsg() {
      this.axios
        .get("/api/Index/GetCourse", {
          params: {
            id: this.$route.query.classId
          }
        })
        .then(e => {
          if (e.data.code == 0) {
            if (!e.data.msg[0].type) {
              this.msg = e.data.msg[0];
              this.sendMsg();
            } else {
              this.msg = e.data.msg[0];
              this.videoUrl = 'videoImg';
              this.videoDom = document.querySelector("#video");
              this.videoEvent();
            }
          }
        });
    },
    videoEvent() {
      if (this.videoDom) {
        this.videoDom.onplay = e => {
          this.videoInterval = setInterval(() => {
            // console.log('send');
            this.sendMsg();
          }, 10000);
        };
        this.videoDom.onpause = e => {
          clearInterval(this.videoInterval);
        };
        this.videoDom.onended = e => {
          this.sendMsg();
        };
      }
    },
    control() {
      // this.videoDom.play()
      if (this.videoDom.paused) {
        this.videoDom.play();
      } else {
        this.videoDom.pause();
      }
    },
    sendMsg() {
      this.videoAllTime = this.videoDom.duration;
      let snMsg = {
        userid: sessionStorage.getItem("id"),
        studyid: this.$route.query.studyId,
        kejianid: this.$route.query.classId,
        kejianname: this.msg.title,
        kejiantime: Math.ceil(this.videoAllTime),
        xuexitime: Math.ceil(this.videoDom.currentTime),
        integral: 1
      };
      // Math.ceil(this.videoDom.currentTime)
      if (!this.msg.type) {
        snMsg.kejiantime = 1;
        snMsg.xuexitime = 1;
        snMsg.integral = 0;
      }

      this.axios.post("/api/Index/PostLearningrecord", snMsg).then(e => {
        // console.log(e.data);
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.videoInterval);
    this.videoInterval = 0;
  }
};
</script>
<style lang='scss' scoped>
.have-class {
  &-video {
    video {
      background: #000;
    }
  }
  &-html {
    padding: 0.2rem;
    word-break: break-all;
  }
  &-source {
    font-size: 0.28rem;
    color: #999999;
    text-align: left;
    padding: 0.2rem;
  }
  &-title {
    line-height: 2;
    text-align: center;
    font-size: 0.4rem;
    font-weight: bold;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
  background: #fff;
  height: 100vh;
}
</style>
<style lang="scss" >
.have-class {
  img {
    width: 100%;
  }
  video {
    width: 100%;
  }
}
</style>